<template>
    <div class="leaveRequest">
        <el-dialog title="外勤申请" :visible.sync="sta" width="810px" :before-close="cancel">
            <div class="leaveRequest_content">
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span> 申请人：
                        </span>
                        <div style="position:relative">
                            <!-- <el-input
                                v-model="Form.partmentName"
                                @focus="departpopshow=!departpopshow"
                                placeholder="不限"
                                clearable
                            ></el-input>
                            <div class="departpop" v-show="departpopshow">
                                <el-tree
                                    :default-expand-all="true"
                                    :data="departmentList"
                                    :props="defaultProps"
                                    @node-click="handleNodeClick"
                                >
                                    <span class="custom-tree-node" slot-scope="{ node,data}">
                                        <div>
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='区'"
                                                src="../../../assets/icon/quyu.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='店'"
                                                src="../../../assets/icon/dian.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='组'"
                                                src="../../../assets/icon/zu.png"
                                                alt
                                            />
                                            <span>{{ data.name }}</span>
                                        </div>
                                    </span>
                                </el-tree>
                            </div>-->
                            <el-select
                                v-model="Form.employeeId"
                                placeholder="不限"
                                @visible-change="Getmessage"
                                @change="queryCheckEmployee(),queryShifts()"
                                clearable
                            >
                                <el-option
                                    v-for="(item,index) in userList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item_div">
                        <span class="label">申请时间：</span>
                        {{curTime}}
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>开始时间：
                        </span>
                        <el-date-picker
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            v-model="Form.beginDatetime"
                            @change="getholidayNumber()"
                            placeholder="请选择"
                        ></el-date-picker>
                    </div>
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>结束时间：
                        </span>
                        <el-date-picker
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            v-model="Form.endDatetime"
                            @change="getholidayNumber()"
                            placeholder="请选择"
                        ></el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">时长：</span>
                        <el-input :disabled="true" v-model="Form.holidayNumber" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>事由：
                        </span>
                        <el-input v-model="Form.applyDemo" type="textarea" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">图片：</span>
                        <el-upload
                            class="avatar-uploader"
                            :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :on-error="handleAvatarError"
                            :headers="headers"
                            :multiple="true"
                            accept=".png, .jpg, .jpeg"
                        >
                            <img
                                v-if="Form.pictureIds"
                                :src="'http://'+Form.pictureIds"
                                class="avatar"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!-- <el-input v-model="input" type="textarea" placeholder="请输入内容"></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="item_div" v-if="checkList.length!=0">
                        <span class="label">审批人：</span>
                        <!-- <div class="item_list" v-for="(ite,index) in checkList" :key="index">
                            <div v-for="(item,index) in ite.names" :key="index">
                                <span class="person">{{item}}</span>
                                <i class="iconfont1 el-icon-minus" v-if="index!=ite.names.length-1"></i>
                            </div>
                            <i v-if="index!=checkList.length-1" class="iconfont1 el-icon-plus"></i>
                        </div>-->
                        <div class="item_list">
                            <div v-for="(item,index) in checkList" :key="index">
                                <span class="person" v-if="item!='-'&&item!='+'">{{item}}</span>
                                <i v-if="item=='-'" class="iconfont1 el-icon-minus"></i>
                                <i v-if="item=='+'" class="iconfont1 el-icon-plus"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-foot">
                <button class="foot-cancel" @click="cancel">取消</button>
                <button v-points class="foot-save" @click="save">确定</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {
    holidayQuery,
    addApplication,
    queryCheckEmployee,
    queryShifts
} from "@/api/checkingIn";
import { departmentFind, employeeQuery } from "@/api/manageCenter";
import { currentTime } from "@/vue/util/tool";
import { getRouterLevel } from "@/vue/util/tool";
export default {
    props: {
        sta: false
    },

    data() {
        let curTime = currentTime();
        let token = sessionStorage.getItem("accessToken") || "";
        return {
            curTime,
            headers: {
                accessToken: token
            },
            departpopshow: false,
            departmentList: [],
            userList: [],
            holidayList: [],
            shiftList: [],
            checkList: [], //审批人列表
            newshiftList: [], //上班时间
            specialDays: [], //特殊时间
            Form: {
                applyId: "3", //
                partmentName: "", //部门
                partmenId: "", //部门id
                applyDemo: "", //备注
                employeeId: "", //申请人编号
                holidayTypeId: "", //请假类型编号
                beginDatetime: "", //请假开始时间
                endDatetime: "", //请假结束时间
                holidayNumber: "", //请假时长
                pictureIds: "" //附件url
            },
            defaultProps: {
                children: "child"
            },
            storeId: "",
            time: "",
            errorMsg: ""
        };
    },

    mounted() {
        // this.getdepartmentFindAll();
        this.holidayQuery();
    },

    methods: {
        cancel() {
            this.$emit("cancel", false);
        },
        // 获取部门
        getdepartmentFindAll() {
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },

        holidayQuery() {
            // 查询请假类型列表
            let params = {
                whetherOpen: "YES"
            };
            this.$post(holidayQuery, params).then(res => {
                if (res.success) {
                    this.holidayList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        Getmessage(val) {
            //    员工列表/查询员工
            if (val) {
                var params = {
                    permissionLevel: getRouterLevel("申请人"),
                    status:'ENABLE',
                };
                this.$post(employeeQuery, params).then(res => {
                    if (res.success === true) {
                        this.userList = res.data;
                    }
                });
            }
        },

        queryCheckEmployee() {
            // 审批人列表
            if (this.Form.employeeId) {
                let params = {
                    employeeId: this.Form.employeeId,
                    id: this.Form.applyId
                };
                this.$post(queryCheckEmployee, params).then(res => {
                    if (res.success) {
                        this.checkList = [];
                        if (res.data.length != 0) {
                            res.data.map((item, index) => {
                                if (item.names.length != 0) {
                                    item.names.map((ite, idx) => {
                                        this.checkList.push(ite);
                                        if (idx != item.names.length - 1) {
                                            this.checkList.push("-");
                                        }
                                    });
                                    if (index != res.data.length - 1) {
                                        this.checkList.push("+");
                                    }
                                }
                            });
                        }
                    }
                });
            }
        },

        queryShifts() {
            // 查询补卡班次列表
            if (this.Form.employeeId) {
                let params = {
                    employeeId: this.Form.employeeId,
                    id: this.Form.applyId,
                    whether: 'no'
                };
                this.$post(queryShifts, params).then(res => {
                    if (res.success === true) {
                        this.shiftList = res.data;
                        if (this.shiftList.length == 0) {
                            this.$message.error("打卡班次为空");
                        }
                        if (this.Form.beginDatetime && this.Form.endDatetime) {
                            console.log(111);
                            this.getholidayNumber();
                        }
                        this.errorMsg = ""
                    }else{
                        this.$message.error(res.msg)
                        this.errorMsg = res.msg
                    }
                });
            }
        },

        computedholidayNumber(begin, end, yeardaymouth) {
            let cardlength = this.shiftList.length;
            let year = yeardaymouth.split("-")[0];
            let mouth =
                yeardaymouth.split("-")[1] < 10
                    ? "0" + yeardaymouth.split("-")[1]
                    : yeardaymouth.split("-")[1];
            let day =
                yeardaymouth.split("-")[2] < 10
                    ? "0" + yeardaymouth.split("-")[2]
                    : yeardaymouth.split("-")[2];
            let curyearmouthday = year + "-" + mouth + "-" + day;
            let begintime = curyearmouthday + " " + begin;
            let endtime = curyearmouthday + " " + end;

            console.log(begintime);
            let curweek = new Date(begintime).getDay();
            if (this.newshiftList.indexOf(curweek) == -1) {
                return 0;
            }
            let isspecialDay = true;
            this.specialDays.map(item => {
                console.log(111, item, curyearmouthday);
                if (item == curyearmouthday) {
                    isspecialDay = false;
                }
            });
            console.log(22222, isspecialDay);
            if (!isspecialDay) {
                return 0;
            }
            if (cardlength == 2) {
                if (
                    new Date(begintime).getTime() <
                    new Date(
                        curyearmouthday + " " + this.shiftList[0].shifts
                    ).getTime()
                ) {
                    // 开始时间在打卡时间之前
                    begintime =
                        curyearmouthday + " " + this.shiftList[0].shifts;
                } else if (
                    new Date(begintime).getTime() >
                    new Date(
                        curyearmouthday + " " + this.shiftList[1].shifts
                    ).getTime()
                ) {
                    // 开始时间在打卡时间之后
                    return 0;
                } else {
                    begintime = begintime;
                }
                if (
                    new Date(endtime).getTime() <
                    new Date(
                        curyearmouthday + " " + this.shiftList[0].shifts
                    ).getTime()
                ) {
                    // 结束时间在打卡时间之前
                    return 0;
                } else if (
                    new Date(endtime).getTime() >
                    new Date(
                        curyearmouthday + " " + this.shiftList[1].shifts
                    ).getTime()
                ) {
                    // 结束时间在打卡时间之后
                    endtime = curyearmouthday + " " + this.shiftList[1].shifts;
                } else {
                    endtime = endtime;
                }
                return (
                    (new Date(endtime).getTime() -
                        new Date(begintime).getTime()) /
                    3600000
                );
            } else if (cardlength == 4) {
                if (
                    new Date(begintime).getTime() <=
                    new Date(
                        curyearmouthday + " " + this.shiftList[0].shifts
                    ).getTime()
                ) {
                    // 开始时间在打卡时间之前
                    if (
                        new Date(endtime).getTime() <=
                        new Date(
                            curyearmouthday + " " + this.shiftList[0].shifts
                        ).getTime()
                    ) {
                        return 0;
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[0].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(endtime).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[0].shifts
                                ).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[0].shifts
                                ).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[0].shifts
                                ).getTime() +
                                (new Date(endtime).getTime() -
                                    new Date(
                                        curyearmouthday +
                                            " " +
                                            this.shiftList[2].shifts
                                    ).getTime())) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[3].shifts
                        ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[0].shifts
                                ).getTime() +
                                (new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[3].shifts
                                ).getTime() -
                                    new Date(
                                        curyearmouthday +
                                            " " +
                                            this.shiftList[2].shifts
                                    ).getTime())) /
                            3600000
                        );
                    }
                } else if (
                    new Date(begintime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[0].shifts
                        ).getTime() &&
                    new Date(begintime).getTime() <=
                        new Date(
                            curyearmouthday + " " + this.shiftList[1].shifts
                        ).getTime()
                ) {
                    // 开始时间在第一与第二次打卡中间
                    begintime = begintime;
                    if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[0].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(endtime).getTime() -
                                new Date(begintime).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(begintime).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(begintime).getTime() +
                                (new Date(endtime).getTime() -
                                    new Date(
                                        curyearmouthday +
                                            " " +
                                            this.shiftList[2].shifts
                                    ).getTime())) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[3].shifts
                        ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() -
                                new Date(begintime).getTime() +
                                (new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[3].shifts
                                ).getTime() -
                                    new Date(
                                        curyearmouthday +
                                            " " +
                                            this.shiftList[2].shifts
                                    ).getTime())) /
                            3600000
                        );
                    }
                } else if (
                    new Date(begintime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[1].shifts
                        ).getTime() &&
                    new Date(begintime).getTime() <=
                        new Date(
                            curyearmouthday + " " + this.shiftList[2].shifts
                        ).getTime()
                ) {
                    // 开始时间在第二与第三次打卡中间
                    if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[1].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime()
                    ) {
                        return 0;
                    } else if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(endtime).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[2].shifts
                                ).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[3].shifts
                        ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime() -
                                new Date(
                                    curyearmouthday +
                                        " " +
                                        this.shiftList[2].shifts
                                ).getTime()) /
                            3600000
                        );
                    }
                } else if (
                    new Date(begintime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[2].shifts
                        ).getTime() &&
                    new Date(begintime).getTime() <=
                        new Date(
                            curyearmouthday + " " + this.shiftList[3].shifts
                        ).getTime()
                ) {
                    // 开始时间在第三与第四次打卡中间
                    begintime = begintime;
                    if (
                        new Date(endtime).getTime() >
                            new Date(
                                curyearmouthday + " " + this.shiftList[2].shifts
                            ).getTime() &&
                        new Date(endtime).getTime() <=
                            new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime()
                    ) {
                        return (
                            (new Date(endtime).getTime() -
                                new Date(begintime).getTime()) /
                            3600000
                        );
                    } else if (
                        new Date(endtime).getTime() >
                        new Date(
                            curyearmouthday + " " + this.shiftList[3].shifts
                        ).getTime()
                    ) {
                        return (
                            (new Date(
                                curyearmouthday + " " + this.shiftList[3].shifts
                            ).getTime() -
                                new Date(begintime).getTime()) /
                            3600000
                        );
                    }
                } else if (
                    new Date(begintime).getTime() >
                    new Date(
                        curyearmouthday + " " + this.shiftList[3].shifts
                    ).getTime()
                ) {
                    // 开始时间在第四次打卡之后
                    return 0;
                }
            }
        },

        getholidayNumber() {
            // 每周打卡时间
            if(this.errorMsg){
                this.$message.error(this.errorMsg);
                return false;
            }
            if (!this.shiftList[0]) {
                this.$message.error("请选择申请人以及请假类型");
                return false;
            }
            if (!this.Form.endDatetime || !this.Form.beginDatetime) {
                return;
            }
            if (
                new Date(this.Form.endDatetime).getTime() <=
                new Date(this.Form.beginDatetime).getTime()
            ) {
                this.$message.error("结束时间必须大于开始时间");
                return false;
            }
            let cardday = this.shiftList[0].days.split(",");
            if (this.shiftList[0].specialDays) {
                this.specialDays = this.shiftList[0].specialDays.split("#");
            }
            cardday.map(item => {
                if (item == "周一") {
                    this.newshiftList.push(1);
                } else if (item == "周二") {
                    this.newshiftList.push(2);
                } else if (item == "周三") {
                    this.newshiftList.push(3);
                } else if (item == "周四") {
                    this.newshiftList.push(4);
                } else if (item == "周五") {
                    this.newshiftList.push(5);
                } else if (item == "周六") {
                    this.newshiftList.push(6);
                } else if (item == "周日") {
                    this.newshiftList.push(0);
                }
            });
            console.log(11111, this.newshiftList);
            let beginday = this.Form.beginDatetime.split(" ")[0].split("-")[2];
            let endday = this.Form.endDatetime.split(" ")[0].split("-")[2];
            let beginmouth = this.Form.beginDatetime
                .split(" ")[0]
                .split("-")[1];
            let endmouth = this.Form.endDatetime.split(" ")[0].split("-")[1];
            let beginyear = this.Form.beginDatetime.split(" ")[0].split("-")[0];
            let endyear = this.Form.endDatetime.split(" ")[0].split("-")[0];
            let beginhour = this.Form.beginDatetime.split(" ")[1].split(":")[0];
            let endhour = this.Form.endDatetime.split(" ")[1].split(":")[0];
            let beginminute = this.Form.beginDatetime
                .split(" ")[1]
                .split(":")[1];
            let endminute = this.Form.endDatetime.split(" ")[1].split(":")[1];
            let dayresult = endday - beginday;
            let mouthresult = endmouth - beginmouth;
            let yearresult = endyear - beginyear;

            // 当日
            if (yearresult == 0 && mouthresult == 0 && dayresult == 0) {
                let curweek = new Date(this.Form.beginDatetime).getDay();
                let isspecialDay = true;
                this.specialDays.map(item => {
                    if (item == this.Form.beginDatetime.split(" ")[0]) {
                        isspecialDay = false;
                    }
                });
                if (!isspecialDay) {
                    this.$message.error("当前日期不需打卡");
                    this.holidayNumber = 0;
                    return false;
                }
                if (this.newshiftList.indexOf(curweek) == -1) {
                    this.$message.error("当前日期为休息日");
                    return false;
                } else {
                    console.log(21312312312);
                    this.Form.holidayNumber = this.computedholidayNumber(
                        this.Form.beginDatetime.split(" ")[1],
                        this.Form.endDatetime.split(" ")[1],
                        this.Form.endDatetime.split(" ")[0]
                    ).toFixed(2)
                }
            } else {
                // 非当日
                let num = 0;
                let beginY = parseInt(beginyear);
                let endY = parseInt(endyear);
                let beginM =
                    beginmouth.split("")[0] == 0
                        ? beginmouth.split("")[1]
                        : beginmouth;
                let endM =
                    endmouth.split("")[0] == 0
                        ? endmouth.split("")[1]
                        : endmouth;

                beginM = parseInt(beginM);
                endM = parseInt(endM);

                let beginD =
                    beginday.split("")[0] == 0
                        ? beginday.split("")[1]
                        : beginday;
                let endD =
                    endday.split("")[0] == 0 ? endday.split("")[1] : endday;

                beginD = parseInt(beginD);
                endD = parseInt(endD);

                for (let y = beginY; y <= endY; y++) {
                    // 循环年份
                    if (beginyear == endY) {
                        // 同年
                        for (let m = beginM; m <= endM; m++) {
                            // 循环月份
                            if (beginM == endM) {
                                // 同月
                                for (let d = beginD; d <= endD; d++) {
                                    if (d == beginD) {
                                        num += this.computedholidayNumber(
                                            this.Form.beginDatetime.split(
                                                " "
                                            )[1],
                                            "23:59:59",
                                            y + "-" + m + "-" + d
                                        );
                                    } else if (d == endD) {
                                        num += this.computedholidayNumber(
                                            "00:00:00",
                                            this.Form.endDatetime.split(" ")[1],
                                            y + "-" + m + "-" + d
                                        );
                                    } else {
                                        num += this.computedholidayNumber(
                                            this.shiftList[0].shifts,
                                            this.shiftList.length == 2
                                                ? this.shiftList[1].shifts
                                                : this.shiftList[3].shifts,
                                            y + "-" + m + "-" + d
                                        );
                                    }
                                }
                            } else {
                                // 不同月
                                let curendday = new Date(
                                    beginyear,
                                    m,
                                    0
                                ).getDate();
                                if (m == beginM) {
                                    for (let d = beginD; d <= curendday; d++) {
                                        if (d == beginD) {
                                            num += this.computedholidayNumber(
                                                this.Form.beginDatetime.split(
                                                    " "
                                                )[1],
                                                "23:59:59",
                                                y + "-" + m + "-" + d
                                            );
                                        } else {
                                            num += this.computedholidayNumber(
                                                this.shiftList[0].shifts,
                                                this.shiftList.length == 2
                                                    ? this.shiftList[1].shifts
                                                    : this.shiftList[3].shifts,
                                                y + "-" + m + "-" + d
                                            );
                                        }
                                    }
                                } else if (m == endM) {
                                    for (let d = 1; d <= endD; d++) {
                                        if (d == endD) {
                                            num += this.computedholidayNumber(
                                                "00:00:00",
                                                this.Form.endDatetime.split(
                                                    " "
                                                )[1],
                                                y + "-" + m + "-" + d
                                            );
                                        } else {
                                            num += this.computedholidayNumber(
                                                this.shiftList[0].shifts,
                                                this.shiftList.length == 2
                                                    ? this.shiftList[1].shifts
                                                    : this.shiftList[3].shifts,
                                                y + "-" + m + "-" + d
                                            );
                                        }
                                    }
                                } else if (m != beginM && m != endM) {
                                    for (let d = 1; d <= curendday; d++) {
                                        num += this.computedholidayNumber(
                                            this.shiftList[0].shifts,
                                            this.shiftList.length == 2
                                                ? this.shiftList[1].shifts
                                                : this.shiftList[3].shifts,
                                            y + "-" + m + "-" + d
                                        );
                                    }
                                }
                            }
                        }
                    } else {
                        // 不同年
                        if (y == beginyear) {
                            // 第一年
                            for (let m = beginM; m <= 12; m++) {
                                let curendday = new Date(
                                    beginyear,
                                    m,
                                    0
                                ).getDate();
                                if (m == beginM) {
                                    for (let d = beginD; d <= curendday; d++) {
                                        if (d == beginD) {
                                            num += this.computedholidayNumber(
                                                this.Form.beginDatetime.split(
                                                    " "
                                                )[1],
                                                "23:59:59",
                                                y + "-" + m + "-" + d
                                            );
                                        } else {
                                            num += this.computedholidayNumber(
                                                this.shiftList[0].shifts,
                                                this.shiftList.length == 2
                                                    ? this.shiftList[1].shifts
                                                    : this.shiftList[3].shifts,
                                                y + "-" + m + "-" + d
                                            );
                                        }
                                    }
                                } else if (m != beginM && m != endM) {
                                    for (let d = 0; d <= curendday; d++) {
                                        num += this.computedholidayNumber(
                                            this.shiftList[0].shifts,
                                            this.shiftList.length == 2
                                                ? this.shiftList[1].shifts
                                                : this.shiftList[3].shifts,
                                            y + "-" + m + "-" + d
                                        );
                                    }
                                }
                            }
                        } else {
                            // 第二年
                            for (let m = 1; m <= endM; m++) {
                                let curendday = new Date(
                                    beginyear,
                                    m,
                                    0
                                ).getDate();
                                if (m == endM) {
                                    for (let d = 1; d <= endD; d++) {
                                        if (d == endD) {
                                            num += this.computedholidayNumber(
                                                "00:00:00",
                                                this.Form.endDatetime.split(
                                                    " "
                                                )[1],
                                                y + "-" + m + "-" + d
                                            );
                                        } else {
                                            num += this.computedholidayNumber(
                                                this.shiftList[0].shifts,
                                                this.shiftList.length == 2
                                                    ? this.shiftList[1].shifts
                                                    : this.shiftList[3].shifts,
                                                y + "-" + m + "-" + d
                                            );
                                        }
                                    }
                                } else if (m != beginM && m != endM) {
                                    for (let d = 1; d <= curendday; d++) {
                                        num += this.computedholidayNumber(
                                            this.shiftList[0].shifts,
                                            this.shiftList.length == 2
                                                ? this.shiftList[1].shifts
                                                : this.shiftList[3].shifts,
                                            y + "-" + m + "-" + d
                                        );
                                    }
                                }
                            }
                        }
                    }
                }
                this.Form.holidayNumber = num.toFixed(2);
            }
        },
        save() {
            if (!this.Form.employeeId) {
                this.$message.error("申请人不能为空");
                return;
            } else if (!this.Form.beginDatetime) {
                this.$message.error("开始时间不能为空");
                return;
            } else if (!this.Form.endDatetime) {
                this.$message.error("结束时间不能为空");
                return;
            } else if (!this.Form.applyDemo) {
                this.$message.error("事由不能为空");
                return;
            }
            let params = Object.assign({}, this.Form);
            this.$post(addApplication, params).then(res => {
                if (res.success) {
                    this.$message.success(res.msg);
                    this.$emit("cancel", false);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleNodeClick(node, data) {
            this.Form.partmentName = node.name;
            this.Form.partmenId = node.id;
            this.departpopshow = false;
        },
        handleAvatarError(err, file, fileList) {},
        handleAvatarSuccess(res, file) {
            if (res.code==200){
                this.Form.pictureIds = res.uri;
            } else {
                this.$message.error(res.msg)
            }
            // this.Form.pictureIds = res.uri;
            //cosole.log(21323,res)
        }
    }
};
</script>



<style lang="less">
.leaveRequest {
    .el-dialog {
        .el-input__icon {
            line-height: 26px !important;
        }
        .avatar-uploader-icon {
            line-height: 90px !important;
        }
        .el-dialog__header {
            padding: 20px 30px 0 30px;
        }
        .el-dialog__body {
            .leaveRequest_content {
                padding: 20px 30px 0 30px;
                .departpop {
                    width: 170px;
                    position: absolute;
                    left: 0;
                    top: 41px;
                    z-index: 10;
                    border: 1px solid #eee;
                    .tree-item {
                        display: flex;
                        align-items: center;
                        img {
                            padding-right: 10px;
                        }
                    }
                }
                .item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &_div {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        .label {
                            min-width: 80px;
                            display: inline-block;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            text-align: right;
                            .notice {
                                color: #ff0000;
                            }
                        }
                        .iconfont1 {
                            color: #90b5ff;
                        }
                        .item_list {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            flex-wrap: wrap;
                            & > div {
                                margin-top: 10px;
                            }
                        }
                        .person {
                            display: inline-block;
                            width: 54px;
                            height: 54px;
                            line-height: 54px;
                            margin: 0 2px;
                            text-align: center;
                            background: rgba(144, 181, 255, 1);
                            border-radius: 50%;
                            color: #ffffff;
                        }
                        .el-input {
                            width: 120px;
                            height: 26px;
                            margin-right: 20px;
                            .el-input__inner {
                                padding: 0 10px;
                                height: 26px;
                            }
                        }
                        .el-date-editor {
                            width: 200px;
                            .el-input__inner {
                                width: 200px;
                                padding: 0 30px;
                                height: 26px;
                                line-height: 26px;
                            }
                        }
                    }
                }
            }
            .dialog-foot {
                text-align: right;
                margin-top: 50px;
                background: #f5f5f5;
                padding: 20px;
                .foot-cancel,
                .foot-save {
                    width: 80px;
                    height: 40px;
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-right: 20px;
                }
                .foot-cancel {
                    background: #cccccc;
                }
                .foot-save {
                    background: #5e75e6;
                }
            }
        }
    }
}
</style>